import React from "react";
import "./style.css";

function NotFoundPage({ handleClick }) {
    return (
        <div className="notfound-container">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>The page you are looking for does not exist.</p>
            <button onClick={() => handleClick("/")}>Go to Home</button>
        </div>
    );
}

export default NotFoundPage;
